import {
  SUCCESS,
  FAIL,
  GET_RULES,
  GET_RULE_BY_ID,
  GET_RULES_FOR_CHECKLIST,
  GET_RULES_FOR_SURVEY,
  CREATE_RULE,
  UPDATE_RULE,
  DELETE_RULE,
  ACTIVATE_RULE,
  DEACTIVATE_RULE,
  PREVIEW_RULE_MATCHES,
  CHECK_TAG_USED_IN_RULES,
  CHECK_ATTRIBUTE_USED_IN_RULES,
} from "../action_types";

const STATE_INIT = {
  isLoading: false,
  rules: [],
  ruleDetails: null,
  checklistRules: [],
  surveyRules: [],
  previewData: null,
  tagUsedInRules: false,
  attributeUsedInRules: false,
  error: {},
};

export default (state = STATE_INIT, { type, payload }) => {
  switch (type) {
    case GET_RULES:
      return { ...state, isLoading: true };
    case `${GET_RULES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        rules: [...(payload || [])],
      };
    case `${GET_RULES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_RULE_BY_ID:
      return { ...state, isLoading: true };
    case `${GET_RULE_BY_ID}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        ruleDetails: payload,
      };
    case `${GET_RULE_BY_ID}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_RULES_FOR_CHECKLIST:
      return { ...state, isLoading: true };
    case `${GET_RULES_FOR_CHECKLIST}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        checklistRules: [...(payload || [])],
      };
    case `${GET_RULES_FOR_CHECKLIST}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case GET_RULES_FOR_SURVEY:
      return { ...state, isLoading: true };
    case `${GET_RULES_FOR_SURVEY}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        surveyRules: [...(payload || [])],
      };
    case `${GET_RULES_FOR_SURVEY}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case CREATE_RULE:
      return { ...state, isLoading: true };
    case `${CREATE_RULE}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        rules: [...state.rules, payload],
      };
    case `${CREATE_RULE}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case UPDATE_RULE:
      return { ...state, isLoading: true };
    case `${UPDATE_RULE}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        rules: state.rules.map((r) => (r.id === payload.id ? payload : r)),
        checklistRules: state.checklistRules.map((r) => (r.id === payload.id ? payload : r)),
      };
    case `${UPDATE_RULE}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case DELETE_RULE:
      return { ...state, isLoading: true };
    case `${DELETE_RULE}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        rules: state.rules.filter((r) => r.id !== payload.ruleId),
        checklistRules: state.checklistRules.filter((r) => r.id !== payload.ruleId),
      };
    case `${DELETE_RULE}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case ACTIVATE_RULE:
    case DEACTIVATE_RULE:
      return { ...state, isLoading: true };
    case `${ACTIVATE_RULE}_${SUCCESS}`:
    case `${DEACTIVATE_RULE}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        rules: state.rules.map((r) => (r.id === payload.id ? payload : r)),
        checklistRules: state.checklistRules.map((r) => (r.id === payload.id ? payload : r)),
      };
    case `${ACTIVATE_RULE}_${FAIL}`:
    case `${DEACTIVATE_RULE}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case PREVIEW_RULE_MATCHES:
      return { ...state, isLoading: true };
    case `${PREVIEW_RULE_MATCHES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        previewData: payload,
      };
    case `${PREVIEW_RULE_MATCHES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case CHECK_TAG_USED_IN_RULES:
      return { ...state, isLoading: true };
    case `${CHECK_TAG_USED_IN_RULES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        tagUsedInRules: payload?.isUsed || false,
      };
    case `${CHECK_TAG_USED_IN_RULES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    case CHECK_ATTRIBUTE_USED_IN_RULES:
      return { ...state, isLoading: true };
    case `${CHECK_ATTRIBUTE_USED_IN_RULES}_${SUCCESS}`:
      return {
        ...state,
        isLoading: false,
        attributeUsedInRules: payload?.isUsed || false,
      };
    case `${CHECK_ATTRIBUTE_USED_IN_RULES}_${FAIL}`:
      return { ...state, isLoading: false, error: { ...payload } };

    default:
      return state;
  }
};

